export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Search"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["You're in Demo Mode. Balances and transactions are simulated."])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Go Live Now"])}
}